import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bonusomat-spin-modal__content" }
const _hoisted_2 = { class: "bonusomat-spin-modal__allwyn-joker-img-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "bonusomat-spin-modal__allwyn"
}

import { computed, ref, watch } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { sazkaAlert } from "@sazka/utils/sazka-alert";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatSpinAutomat from "./bonusomat-spin-modal/bonusomat-spin-automat.vue";
import BonusomatSpinButtons from "./bonusomat-spin-modal/bonusomat-spin-buttons.vue";
import BonusomatSpinFooter from "./bonusomat-spin-modal/bonusomat-spin-footer.vue";
import BonusomatSpinWinner from "./bonusomat-spin-modal/bonusomat-spin-winner.vue";
import { callBonusomatSpin } from "../../api/bonusomat-player-data-api";
import useBonusomatData from "../../composables/use-bonusomat-data";
import { BonusomatSlotsSpin } from "../../models/bonusomat-slots";
import { SpinAutomatState } from "../../models/bonusomat-spin-types";
import { BonusomatDatalayer } from "../../utils/analytics/bonusomat-datalayer";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-spin-modal',
  props: {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["open-win-table"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const emit = __emit;

const modelValue = _useModel<boolean>(__props, "modelValue");

const { session, refreshBalance } = useNgSession();

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount, loadBonusomatPlayerData } = bonusomatPlayerStatus;
const { allwynDrawData, loadAllwynDrawData } = useBonusomatData();

const state = ref<SpinAutomatState>("EMPTY");
const allwynInformationPageUrl = appSettings["AllwynExperiencePageUrl"];
const winData = ref<BonusomatSlotsSpin>(null);

const isCurrentlySpinning = computed(() => state.value == "ROLLING" || state.value == "STOPPING");
const isWinningWithAllwyn = computed(() => allwynDrawData.value && state.value == "WINNING");
const isWinningJoker = computed(() => state.value === "WINNING" && winData.value?.awardType?.toLowerCase() == "joker");

const modClass = computed(() => {
    return {
        lighten: state.value != "DISABLED" && state.value != "WINNING",
        winner: state.value === "WINNING" && winData.value?.winBoxTitle,
        joker: isWinningJoker.value,
        allwyn: isWinningWithAllwyn.value,
    };
});

const initModalState = () => {
    const isLastSpinToday = bonusomatPlayerData.value.lastSpin
        ? DateTimeUtils.isToday(new Date(bonusomatPlayerData.value.lastSpin))
        : false;
    if (isLastSpinToday && remainingSpinsCount.value > 0) {
        state.value = "DISABLED";
    } else if (remainingSpinsCount.value > 0) {
        state.value = "ACTIVE";
    } else {
        state.value = "EMPTY";
    }
};

const startSpinHandler = async () => {
    try {
        state.value = "ROLLING";
        const delay = new Promise((resolve) => setTimeout(resolve, 2800));

        winData.value = await callBonusomatSpin(session.value?.PlayerID);
        await delay;

        BonusomatDatalayer.pushSuccessfullSpin();

        state.value = "STOPPING";
    } catch (err: unknown) {
        sazkaAlert("Chyba", "Při pokusu točení Bonusomatem se nám něco nepovedlo. Zkuste to prosím znovu.");
        state.value = "ACTIVE";

        BonusomatDatalayer.pushSpinError(err as string);
    }
};

const spinStoppedHandler = async () => {
    state.value = "WINNING";
};

const showWinnerTableHandler = () => {
    emit("open-win-table");
};

const closeModalInternal = async () => {
    if (state.value == "WINNING") {
        await loadBonusomatPlayerData();
        await refreshBalance(true);

        if (allwynDrawData.value) {
            await loadAllwynDrawData();
        }
    }
};

watch(
    modelValue,
    (newModalIsOpen, oldModalIsOpen) => {
        if (newModalIsOpen) {
            initModalState();
        } else if (oldModalIsOpen) {
            closeModalInternal();
        }
    },
    {
        immediate: true,
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    "prevent-close": isCurrentlySpinning.value,
    theme: "dark",
    class: _normalizeClass(["bonusomat-spin-modal", modClass.value])
  }, {
    top: _withCtx(() => _cache[2] || (_cache[2] = [])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (isWinningJoker.value)
            ? (_openBlock(), _createBlock(WebpImage, {
                key: 0,
                src: "/frontend/web/img/logos/allwyn/allwyn-joker-logo-turquoise.svg",
                alt: "allwyn Joker logo"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(BonusomatSpinWinner, {
          state: state.value,
          "prize-text": winData.value?.winBoxTitle
        }, null, 8, ["state", "prize-text"]),
        _createVNode(BonusomatSpinAutomat, {
          state: state.value,
          "win-icons": [winData.value?.reelIcon1, winData.value?.reelIcon2, winData.value?.reelIcon3],
          onSpinStopped: spinStoppedHandler
        }, null, 8, ["state", "win-icons"]),
        (isWinningWithAllwyn.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(WebpImage, {
                src: "/frontend/web/img/logos/allwyn/allwyn-logo.png",
                alt: "",
                class: "bonusomat-spin-modal__allwyn-logo"
              }),
              _cache[3] || (_cache[3] = _createElementVNode("div", null, "Získali jste lístek do slosování o Allwyn zážitek!", -1))
            ]))
          : _createCommentVNode("", true),
        _createVNode(BonusomatSpinButtons, {
          state: state.value,
          "allwyn-page-url": isWinningWithAllwyn.value ? _unref(allwynInformationPageUrl) : null,
          onSpinClick: startSpinHandler,
          onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
        }, null, 8, ["state", "allwyn-page-url"]),
        _createVNode(BonusomatSpinFooter, {
          "remaining-spins-count": _unref(remainingSpinsCount),
          onShowWinnerTable: showWinnerTableHandler
        }, null, 8, ["remaining-spins-count"])
      ])
    ]),
    bottom: _withCtx(() => _cache[4] || (_cache[4] = [])),
    _: 1
  }, 8, ["modelValue", "prevent-close", "class"]))
}
}

})